import { ACT_AUTH_CHANGE } from "../actions/ActionTypes";

const initialState = {
  login:false
};

export default function(state = initialState, action) {
	if (action.type === ACT_AUTH_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js